export function parseCsvSlugs(value: string | null): string[] {
  if (!value) {
    return [];
  }
  return value.trim().split(/\s*,\s*/);
}
